import { render, staticRenderFns } from "./ContactTemplate.vue?vue&type=template&id=d083fe92&scoped=true&"
import script from "./ContactTemplate.vue?vue&type=script&lang=js&"
export * from "./ContactTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d083fe92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d083fe92')) {
      api.createRecord('d083fe92', component.options)
    } else {
      api.reload('d083fe92', component.options)
    }
    module.hot.accept("./ContactTemplate.vue?vue&type=template&id=d083fe92&scoped=true&", function () {
      api.rerender('d083fe92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/ContactTemplate.vue"
export default component.exports